import React, { useEffect, useRef } from 'react';

import { useField } from '@unform/core';
import { Box, Checkbox, FormControlLabel } from '@material-ui/core';

export default function Check({ name = '', defaultChecked, ...rest }) {
  const inputRef = useRef([]);

  const { fieldName, registerField, error, clearError } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'checked',
    });
  }, [fieldName, registerField]);

  return (
    <>
      <FormControlLabel
        // Props
        inputRef={inputRef}
        control={<Checkbox name={name} color="primary" defaultChecked={defaultChecked} onClick={clearError} />}
        {...rest}
      />
      {Boolean(error) && (
        <Box fontSize={12} color="error.main">
          {error}
        </Box>
      )}
    </>
  );
}
